import { render } from "./PersonalizationButton.vue?vue&type=template&id=16118b65&scoped=true"
import script from "./PersonalizationButton.vue?vue&type=script&lang=js"
export * from "./PersonalizationButton.vue?vue&type=script&lang=js"

import "./PersonalizationButton.vue?vue&type=style&index=0&id=16118b65&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16118b65"]])

export default __exports__